import React, { useEffect } from 'react';
import { Card, Form, Space, Input, Tooltip } from 'antd';

import { formItemLayout } from '../Common';
import { isEmpty } from 'script/common';

const AppName = ({ t, settingKey, settingData, onSave, message }) => {
	const [form] = Form.useForm();

	const initialValues = {
		appName_WORD: settingData?.appName_WORD || "",
		appName_CELL: settingData?.appName_CELL || "",
		appName_SHOW: settingData?.appName_SHOW || "",
		appName_PDF: settingData?.appName_PDF || ""
	}

	useEffect(() => {
		form.setFieldsValue({
			appName_WORD: settingData?.appName_WORD || "",
			appName_CELL: settingData?.appName_CELL || "",
			appName_SHOW: settingData?.appName_SHOW || "",
			appName_PDF: settingData?.appName_PDF || ""
		});
	}, [settingData, form]);


	const onFinish = () => {
		const values = form.getFieldsValue();
		let value = {
			data: {
				appName_WORD: isEmpty(values.appName_WORD) ? "" : values.appName_WORD.trim(),
				appName_CELL: isEmpty(values.appName_CELL) ? "" : values.appName_CELL.trim(),
				appName_SHOW: isEmpty(values.appName_SHOW) ? "" : values.appName_SHOW.trim(),
				appName_PDF: isEmpty(values.appName_PDF) ? "" : values.appName_PDF.trim(),
			}
		};

		onSave(value);
	}

	return (
		<Form {...formItemLayout} form={form} onFinish={onFinish} initialValues={initialValues}>
			<Tooltip  title={t('setting.tooltipcontent.name.label')} placement="leftTop">
			<Card title={t(settingKey.key)} key={settingKey.key} name={['settingKey.key']} style={{ margin: 20 }}>
				{settingKey.keyList && settingKey.keyList.length > 0 ? (
					settingKey.keyList.map((item) => (
						<Card type="inner" key={item.key} title={t(item.key)} style={{ margin: 20 }}>
							<Form.Item
								name={item.value}
							>
								<Input
									name={item.value}
									placeholder={t('settings.msg.invalidLength')}
									maxLength={30}
								/>
							</Form.Item>
						</Card>
					))
				) : (
					<p>No apps available</p>  // apps가 없을 때 표시
				)}
				<Space style={{ float: 'right', margin: 20 }}>
					<button className="btn_text_b">{t('user.account.save')}</button>
				</Space>
			</Card>
			</Tooltip>
		</Form>
	);
};

export default AppName;